// React
import {
  Row,
  Col,
  Card,
  Form,
  Label,
  Input,
  CardBody,
  CardFooter,
} from 'reactstrap';
import React from 'react';

// Injections
import { PageWrapper } from '../../containers/componentsInjection';

export const FormCategoriesPlansPage = ({ validation, history, id }) => {
  return (
    <PageWrapper
      title={id ? 'Editar categoria de plano' : 'Adicionar categoria de plano'}
    >
      <Row>
        <Col>
          <Card>
            <div className="live-preview">
              <Form
                autoComplete="off"
                onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                  return false;
                }}
              >
                <CardBody>
                  <Row>
                    <Col md={8}>
                      <div className="mb-3">
                        <Label htmlFor="nameInput" className="form-label">
                          Nome
                        </Label>
                        <Input
                          type="text"
                          className="form-control"
                          id="nameInput"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.nameInput || ''}
                        />
                        {validation.touched.nameInput &&
                        validation.errors.nameInput ? (
                          <p className="labelErrorValidation">
                            {validation.errors.nameInput}
                          </p>
                        ) : null}
                      </div>
                    </Col>

                    <Col md={4}>
                      <div className="mb-3 ">
                        <Label htmlFor="renovationInput" className="form-label">
                          Tempo de renovação do contrato
                        </Label>
                        <div className="input-group">
                          <Input
                            type="text"
                            className="form-control form-control-suffix"
                            id="renovationInput"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.renovationInput || ''}
                          />
                          <span className="input-group-text" id="basic-addon2">
                            meses
                          </span>
                        </div>

                        {validation.touched.renovationInput &&
                        validation.errors.renovationInput ? (
                          <p className="labelErrorValidation">
                            {validation.errors.renovationInput}
                          </p>
                        ) : null}
                      </div>
                    </Col>

                    <Col md={12}>
                      <div>
                        <div className="form-check form-switch mb-3">
                          <Input
                            id="isOrganizations"
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            onChange={(e) => {
                              const checked = {
                                target: {
                                  name: 'isOrganizations',
                                  value: e.target.checked,
                                },
                              };
                              validation.handleChange(checked);
                            }}
                            checked={validation.values.isOrganizations}
                            onBlur={validation.handleBlur}
                          />
                          <Label
                            className="form-check-label"
                            htmlFor="isOrganizations"
                          >
                            Exibir organizações
                          </Label>
                        </div>
                      </div>
                    </Col>

                    <Col md={12}>
                      <div>
                        <div className="form-check form-switch mb-3">
                          <Input
                            id="isDetails"
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            onBlur={validation.handleBlur}
                            onChange={(e) => {
                              const checked = {
                                target: {
                                  name: 'isDetails',
                                  value: e.target.checked,
                                },
                              };
                              validation.handleChange(checked);
                            }}
                            checked={validation.values.isDetails}
                          />
                          <Label
                            className="form-check-label"
                            htmlFor="isDetails"
                          >
                            Exibir detalhes do vínculo empregatício
                          </Label>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </CardBody>

                <CardFooter>
                  <Col md={12}>
                    <div className="text-end d-flex justify-content-end">
                      <button
                        type="button"
                        className="btn btn-link"
                        style={{
                          marginRight: '10px',
                        }}
                        onClick={() => {
                          history.push(
                            '/configuracoes/tabelas/categorias-planos'
                          );
                        }}
                      >
                        Cancelar
                      </button>
                      <button type="submit" className="btn btn-primary">
                        {id ? 'Editar' : 'Salvar'}
                      </button>
                    </div>
                  </Col>
                </CardFooter>
              </Form>
            </div>
          </Card>
        </Col>
      </Row>
    </PageWrapper>
  );
};
